export const placeholderPhotoGodzilla = 'https://psi.zdf.de/photos/godzilla_new_york.jpeg';
export const placehodlerPhotoKingKong = 'https://psi.zdf.de/photos/king_kong_toronto.jpeg';
export const placeholderPhotoLizard = 'https://psi.zdf.de/photos/lizard.jpeg';
export const placeholderPhotoMotorcycle = 'https://psi.zdf.de/photos/motorcycle.jpeg';
export const placeholderPhotoTrekWarsBrawl = 'https://psi.zdf.de/photos/trek_wars_brawl.jpeg';

// Numeric aliases
export const placeholderPhoto1 = placeholderPhotoGodzilla;
export const placeholderPhoto2 = placehodlerPhotoKingKong;
export const placeholderPhoto3 = placeholderPhotoLizard;
export const placeholderPhoto4 = placeholderPhotoMotorcycle;
export const placeholderPhoto5 = placeholderPhotoTrekWarsBrawl;
